import React from 'react';
import { createStackNavigator } from '@react-navigation/stack';

import screenOptions from '../config/screenOptions';
import WelcomeNavigator from './WelcomeNavigator';
import LoginNavigator from './LoginNavigator';
import ProfileWorkerTabNavigator from './ProfileWorkerTabNavigator';

import CompanyPlansNavigator from './CompanyPlansNavigator';
import PersonalTrainerNavigator from './PersonalTrainerNavigator';
import ProfileCompany from './ProfileCompanyStackNavigator';
import StudentNavigator from './StudentNavigator';

const Base = createStackNavigator();
const BaseNavigator = () => (
  <Base.Navigator screenOptions={screenOptions}>
    <Base.Screen name="Welcome" component={WelcomeNavigator} />
    <Base.Screen name="Login" component={LoginNavigator} />
    <Base.Screen name="Profile Worker" component={ProfileWorkerTabNavigator} />
    <Base.Screen name="Profile Company" component={ProfileCompany} />
    <Base.Screen name="Profile Trainer" component={PersonalTrainerNavigator} />
    <Base.Screen name="Company Plans" component={CompanyPlansNavigator} />
    <Base.Screen name="Student" component={StudentNavigator} />

  </Base.Navigator>
);

export default BaseNavigator;
